import { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import { useTheme } from "@mui/material/styles";

const GraphPlatformSplit = props => {
  const theme = useTheme();

  const [data, setData] = useState([]);
  const [labels, setLabels] = useState([]);

  useEffect(() => {
    loadPlatformGraphData();
  }, [props.bookings]);

  const loadPlatformGraphData = () => {
    // Create all platforms
    let platforms = [
      { name: "Concierge", totalRevenue: 0 },
      { name: "Guest Platform", totalRevenue: 0 },
      { name: "Taxi Booker", totalRevenue: 0 }
    ];
    let bookings = [];
    for (let booking of props.bookings) {
      if (booking.status === "booked" || booking.status === "closed") {
        bookings.push(booking);
      }
    }

    // Fill data into platforms array
    for (let booking of bookings) {
      if (booking.payment_status == "paid_via_hotel") {
        platforms[0].totalRevenue +=
          booking.total_price_without_fees === null ? 0 : parseFloat(booking.total_price_without_fees);
      } else if (booking.payment_status == "paid") {
        platforms[1].totalRevenue +=
          booking.total_price_without_fees === null ? 0 : parseFloat(booking.total_price_without_fees);
      } else if (booking.payment_status == "paid_via_hotel_taxibooker") {
        platforms[2].totalRevenue +=
          booking.total_price_without_fees === null ? 0 : parseFloat(booking.total_price_without_fees);
      }
    }

    // Prepare graph options and data
    let data = [];
    let labels = [];
    for (let platform of platforms) {
      labels.push(platform.name);
      data.push(platform.totalRevenue.toFixed(2));
    }
    setData(data);
    setLabels(labels);
  };

  const dataObj = {
    labels: labels,
    datasets: [
      {
        backgroundColor: [
          theme.palette.custom.turquoise,
          theme.palette.custom.blueBaby,
          theme.palette.custom.blue,
          theme.palette.custom.greenLight,
          theme.palette.custom.yellow,
          theme.palette.custom.orange,
          theme.palette.custom.purple,
          theme.palette.custom.red,
          theme.palette.custom.grayDark,
          theme.palette.custom.grayBright
        ],
        data: data
      }
    ]
  };
  const options = {
    events: ["click"],
    legend: {
      position: "left",
      labels: {
        boxWidth: 15,
        fontSize: 10,
        fontFamily: "Neutraface2Book"
      }
    },
    circumference: Math.PI,
    rotation: Math.PI
  };

  return (
    <div>
      <Doughnut data={dataObj} options={options} />
    </div>
  );
};

export default GraphPlatformSplit;
